import axios from "axios";

const baseUrl = `${process.env.REACT_APP_BASE_URL}/api`;


export const getAllFromRegistroGeneral = async () => {
    const url = `${ baseUrl }/RegistroGeneral`;

    let result = [];

    await axios.get(url)
    .then((response) => {
        const data = response.data;
        result = { ...data };
    })
    .catch( 
        err => console.log( err )
    );

    return result;
}


export const getById = async (id = '') => {

    const url = `${ baseUrl }/RegistroGeneral/${ id }`

    let result = [];

    await axios.get(url)
    .then((response) => {
        const data = response.data;
        result = { ...data };
    })
    .catch( 
        err => console.log( err )
    );

    return result;
}


// Devuelve todos los registros que correspondan a ese proyecto, 
// en el caso de educones devolvera de todas las fechas ofertadas
export const getByRegistroClaveProyecto = async (registroClaveProyecto = '') => {

    const respuesta = { exito: 0, mensaje: '', data: [] };
    const url = `${ baseUrl }/RegistroGeneral`;

    await axios.get(url)
        .then((response) => {
            const responseData = response.data;
            respuesta.data = responseData.data.filter(rd => rd.registroClaveProyecto === registroClaveProyecto);
            respuesta.exito = 1;
        })
        .catch( 
            err => respuesta.mensaje = err
        );

    return respuesta;
}

// Devuelve 1 registro
export const getByRegistroReferencia = async (registroReferencia = '') => {

    const respuesta = { exito: 0, mensaje: '', data: [] };
    const url = `${ baseUrl }/RegistroGeneral`;

    await axios.get(url)
        .then((response) => {
            const responseData = response.data;
            respuesta.data = responseData.data.filter(rd => rd.registroReferencia === registroReferencia);
            respuesta.exito = 1;
        })
        .catch( 
            err => respuesta.mensaje = err
        );

    return respuesta;
}


export const postOne = async ({ values }) => {
    
    let respuesta = { exito: 0, mensaje: '', data: [] };
    const url = `${ baseUrl }/RegistroGeneral`;

    
    await axios.post(url, values)
        .then( response => {
            respuesta = response.data;
        })
        .catch( 
            err => respuesta.mensaje = err
        );

    return respuesta;
}